import AbstractView from 'abstract'

export class Main extends AbstractView {
  constructor(domElementId) {
    return super(domElementId);
  }

  init() {}
}
